import { computed } from 'vue'
import useUserStore from '@shared/stores/useUserStore'

// A user who already holds a subscription is renewing rather than signing up.
// Several screens are shared between the two funnels and only differ in copy and
// in where their back button leads, so they all ask this same question.
export default function useIsResubscription() {
  const userStore = useUserStore()
  return computed(() => userStore.user?.currentSubscription != null)
}
